export function collectorAgentPrompt(code: string, apiUrl = "https://u.80aj.com"): string {
  return `请在这台电脑上完成 UsageHub 数据采集接入，并一直做到验证成功。

可信来源：
- 开源仓库：https://github.com/cfrs2005/usagehub-open
- 服务地址：${apiUrl}
- 一次性接入码：${code}

执行要求：
1. 只使用开源仓库、公开文档和公开接口。不要调用 Claude 或 Codex 的未公开网络接口。
2. 不要读取、复制或复用 Claude Code、Codex、浏览器的 OAuth 凭证、Cookie 或会话 Token。
3. 检测当前操作系统和已有工具。安装或更新 Node.js 22+、ccusage 20+，然后检出 usagehub-open 的最新 main。
4. 阅读仓库根目录 AGENTS.md，并执行其中的 collector onboarding 流程。
5. 为本机创建稳定、随机的 installation_id。向 ${apiUrl}/v1/collector-enrollments/redeem 兑换一次性接入码。
6. 兑换得到的 uh_ingest_ 密钥不得打印、不得写入 Git、不得写入普通日志。保存到系统钥匙串、凭据管理器或权限 600 的本机密钥文件。
7. Claude 的 5 小时和 7 天额度以未修改的官方 claude 二进制运行「claude -p /usage」为主采集（订阅登录、零 token、不落会话），官方 statusLine 输入为辅；配置 statusLine 时保留用户原有状态栏输出。
8. Codex 只通过本机官方 app-server 只读方法采集额度。Token 与标准 API 等价费用通过 ccusage/ccusage-codex 获取。
9. 安装为当前用户的后台服务，开机自动运行；不得注册成系统桌面，不得修改锁屏或安全策略。
10. 运行仓库检查、三次采集 smoke test，并确认 UsageHub 页面出现 Claude/Codex 数据。

完成后只报告：安装目录、服务状态、最近上报时间和验证结果。不要在回复中显示任何密钥或完整接入码。`;
}
